import { X } from 'lucide-react';
import { toProperCase } from '../utils/helpers';

interface PhotoLightboxProps {
  imageUrl: string;
  playerName: string;
  isOpen: boolean;
  onClose: () => void;
}

const PhotoLightbox = ({ imageUrl, playerName, isOpen, onClose }: PhotoLightboxProps) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div 
        className="relative max-w-3xl max-h-[90vh] animate-in fade-in zoom-in duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
        >
          <X className="w-6 h-6 text-white" />
        </button>

        {/* Image */}
        <img
          src={imageUrl}
          alt={playerName}
          className="max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain"
        />

        {/* Player name */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 rounded-b-lg">
          <p className="text-white text-lg font-semibold text-center">{toProperCase(playerName)}</p>
        </div>
      </div>
    </div>
  );
};

export default PhotoLightbox;

